import superAdminApi from '@/api/super-admin';

export default {
  getAllOrganizations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getAllOrganizations(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setAllOrganization', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getOrganizationsForProxy({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getAllOrganizations()
        .then((response) => {
          const { data } = response || {};

          commit('setProxyOrganizations', data.resources);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getOrganizationDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getOrganizationDetail(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setOrganizationDetail', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  addOrganization({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .addOrganization(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },

  updateOrganization({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .updateOrganization(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setOrganizationDetail', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },

  getOrgCourses({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getOrgCourses(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setOrganizationCourses', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  updateOrgCourseAccess({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .updateOrgCourseAccess(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          commit('setLoading', false);
          reject(err);
        });
    });
  },

  getViolations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolations(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setViolations', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getFeedbacks({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getFeedbacks(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setAllFeedback', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getFeedbackSummary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getFeedbackSummary(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setFeedbackSummary', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationMetrics({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolationMetrics(payload)
        .then((response) => {
          const { data } = response || {};

          commit('setViolationMetrics', data);
          commit('setLoading', false);

          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationsNotified({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getViolationsNotified(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setViolationsNotified', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  changeViolationNotifyStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .changeViolationNotifyStatus(payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationEvents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolationEvents(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setViolationEvents', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationById({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolationById(id)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getUniqueLoggedBrowsersAndDevices({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getUniqueLoggedBrowsersAndDevices()
        .then((response) => {
          const { data } = response || {};
          commit('setDevices', data?.devices || []);
          commit('setBrowsers', data?.browsers || []);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationFilters({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolationFilters()
        .then((response) => {
          const { data } = response || {};
          commit('setViolationFilters', data || []);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  getViolationFilterById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .getViolationFilterById(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },

  saveViolationFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .saveViolationFilter(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setViolationFilterById', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  updateViolationFilter({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .updateViolationFilter(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setViolationFilterById', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  deleteViolationFilter({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .deleteViolationFilter(id)
        .then((response) => {
          commit('deleteViolationFilterById', id);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  shareViolation({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .shareViolation(id, payload)
        .then((response) => {
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  blacklistSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      superAdminApi
        .blacklistSearch(payload)
        .then((response) => {
          const { data } = response || {};
          commit('setBlacklists', data);
          commit('setLoading', false);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
          commit('setLoading', false);
        });
    });
  },

  blacklistBlock(_context, payload) {
    return new Promise((resolve, reject) => {
      superAdminApi
        .blacklistBlock(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  blacklistUnblock(_context, payload) {
    return new Promise((resolve, reject) => {
      superAdminApi
        .blacklistUnblock(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  unlockViolation(_context, payload) {
    return new Promise((resolve, reject) => {
      superAdminApi
        .unlockViolation(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getCourseUrlTypes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      superAdminApi
        .getCourseUrlTypes(payload)
        .then((response) => {
          commit('setCourseUrlTypes', response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getMessageDistributionLists({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getMessageDistributionLists(payload)
        .then((response) => {
          commit('setMessageDistributionLists', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getMessageDistributionListsById({ commit }, payload) {
    commit('setLoading', true);

    return new Promise((resolve, reject) => {
      superAdminApi
        .getMessageDistributionListsById(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getNumberOfAffectedUsers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      superAdminApi
        .getNumberOfAffectedUsers(payload)
        .then((response) => {
          commit('setNumberOfaffectedUsers', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createMessageDistributionList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true);
      superAdminApi
        .createMessageDistributionList(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  updateMessageDistributionList({ commit }, payload) {
    commit('setLoading', true);

    return new Promise((resolve, reject) => {
      superAdminApi
        .updateMessageDistributionList(payload.id, payload.list)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  deleteMessageDistributionLists({ commit }, id) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .deleteMessageDistributionLists(id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },

  getAppMessageById({ commit }, id) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getAppMessageById(id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  createAppMessage({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .createAppMessage(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  updateAppMessage({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .updateAppMessageById(payload.id, payload.formData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  deleteAppMessage({ commit }, id) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .deleteAppMessage(id)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getPendingMessages({ commit }) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getPendingMessages()
        .then((response) => {
          commit('setPendingMessages', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getReleasedMessages({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getReleasedMessages(payload)
        .then((response) => {
          commit('setReleasedMessages', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  uploadFaq({ commit }, payload) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .uploadFaq(payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
  getAccreditingEntities({ commit }) {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      superAdminApi
        .getAccreditingEntities()
        .then((response) => {
          commit('setAccreditingEntities', response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    });
  },
};
